// extracted by mini-css-extract-plugin
export var dropdownButton = "_3e-0";
export var fullWidthDropdownButton = "_3e-1";
export var icon = "_3e-3";
export var iconPlaceholder = "_3e-2";
export var menuItemRow = "_3e-5";
export var shortcutContainer = "_3e-4";